import script from "./loaderGenerateProjList.vue?vue&type=script&lang=ts&setup=true"
export * from "./loaderGenerateProjList.vue?vue&type=script&lang=ts&setup=true"

import "./loaderGenerateProjList.vue?vue&type=style&index=0&id=dcdc83bc&lang=css"
import "./loaderGenerateProjList.vue?vue&type=style&index=1&id=dcdc83bc&scoped=true&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcdc83bc"]])

export default __exports__